var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "gates" } } },
                  [_c("a", [_vm._v("ゲート一覧")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("ゲート編集")])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content detail-gate-edit" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.errorMessageLogs !== ""
              ? _c("div", {
                  staticClass: "alert alert-danger",
                  domProps: { innerHTML: _vm._s(_vm.errorMessageLogs) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.message
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v("\n          " + _vm._s(_vm.message) + "\n        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateId))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品ID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateModelId))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品名")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "product_error" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.gateModelId,
                                            expression: "gateInfor.gateModelId"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          "data-placeholder": "製品名選択"
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.gateInfor,
                                                "gateModelId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              _vm.getGateModelInforWithGateModeId(
                                                _vm.gateInfor.gateModelId
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      _vm._l(_vm.listGateModel, function(
                                        item,
                                        index
                                      ) {
                                        return item.makerCode ===
                                          _vm.gateInfor.makerCode
                                          ? _c(
                                              "option",
                                              {
                                                key: index,
                                                domProps: {
                                                  value: item.gateModelId
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.gateModelName) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("型番")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.gateInfor.gateModelCode)
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowHideAdvance(
                                _vm.gateInfor.makerCode,
                                _vm.gateInfor.customizable
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ターゲット動作設定Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.controlTime,
                                                expression:
                                                  "gateInfor.controlTime"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              max: "10000"
                                            },
                                            domProps: {
                                              value: _vm.gateInfor.controlTime
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.gateInfor,
                                                  "controlTime",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [
                                    _vm._v("ゲート名 "),
                                    _c(
                                      "font",
                                      { staticClass: "input-required" },
                                      [_vm._v("※必須")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    !_vm.isGateNameValid
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "error_m",
                                            attrs: { id: "gate_error" }
                                          },
                                          [_vm._v(_vm._s(_vm.gateNameMessage))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isGateNameValid
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.gateInfor.gateName,
                                              expression: "gateInfor.gateName"
                                            }
                                          ],
                                          staticClass: "form-control input-sm",
                                          attrs: {
                                            type: "text",
                                            id: "gatename"
                                          },
                                          domProps: {
                                            value: _vm.gateInfor.gateName
                                          },
                                          on: {
                                            blur: function($event) {
                                              _vm.validateBeforeSubmit(1)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.gateInfor,
                                                "gateName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.gateInfor.gateName,
                                              expression: "gateInfor.gateName"
                                            }
                                          ],
                                          staticClass:
                                            "form-control input-sm error",
                                          attrs: {
                                            type: "text",
                                            id: "gatename"
                                          },
                                          domProps: {
                                            value: _vm.gateInfor.gateName
                                          },
                                          on: {
                                            blur: function($event) {
                                              _vm.validateBeforeSubmit(1)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.gateInfor,
                                                "gateName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.needLocation
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("位置情報取得")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.needLocation,
                                                expression:
                                                  "gateInfor.needLocation"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.needLocation
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor.needLocation,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.needLocation
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor.needLocation,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.needLocation = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.needLocation = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "needLocation",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.isNFCValid
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("NFCの有効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.gateInfor.isNFCValid,
                                                expression:
                                                  "gateInfor.isNFCValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isNFCValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor.isNFCValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.isNFCValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor.isNFCValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isNFCValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isNFCValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isNFCValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.isTenKeyValid
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("テンキーの有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.isTenKeyValid,
                                                expression:
                                                  "gateInfor.isTenKeyValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isTenKeyValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor.isTenKeyValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.isTenKeyValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor.isTenKeyValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isTenKeyValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isTenKeyValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isTenKeyValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.isGatePasswordValid
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードの有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor
                                                    .isGatePasswordValid,
                                                expression:
                                                  "gateInfor.isGatePasswordValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox",
                                              disabled: _vm.gateInfor.isVisitor
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor
                                                  .isGatePasswordValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor
                                                      .isGatePasswordValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor
                                                    .isGatePasswordValid
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a =
                                                      _vm.gateInfor
                                                        .isGatePasswordValid,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.gateInfor.isGatePasswordValid = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.gateInfor.isGatePasswordValid = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.gateInfor,
                                                      "isGatePasswordValid",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function($event) {
                                                  _vm.validateBeforeSubmit(2)
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gatePasswordLength
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードの桁数")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor
                                                      .gatePasswordLength,
                                                  expression:
                                                    "gateInfor.gatePasswordLength"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                disabled: _vm.getEditStatus()
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "gatePasswordLength",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.listPassLenght, function(
                                              item
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.value,
                                                  domProps: {
                                                    value: item.value
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.text) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            })
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gatePasswordSeed
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードのseed値")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          !_vm.isGatePasswordSeedValid
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "error_m",
                                                  attrs: {
                                                    id: "passwordseed_error"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.gatePasswordSeedMessage
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isGatePasswordSeedValid
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.gateInfor
                                                        .gatePasswordSeed,
                                                    expression:
                                                      "gateInfor.gatePasswordSeed"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-sm",
                                                staticStyle: {
                                                  "text-transform": "uppercase"
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "pseed",
                                                  disabled: _vm.getEditStatus()
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.gateInfor
                                                      .gatePasswordSeed
                                                },
                                                on: {
                                                  blur: function($event) {
                                                    _vm.validateBeforeSubmit(2)
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.gateInfor,
                                                      "gatePasswordSeed",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.gateInfor
                                                        .gatePasswordSeed,
                                                    expression:
                                                      "gateInfor.gatePasswordSeed"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-sm error",
                                                staticStyle: {
                                                  "text-transform": "uppercase"
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "pseed",
                                                  disabled: _vm.getEditStatus()
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.gateInfor
                                                      .gatePasswordSeed
                                                },
                                                on: {
                                                  blur: function($event) {
                                                    _vm.validateBeforeSubmit(2)
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.gateInfor,
                                                      "gatePasswordSeed",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.isTwoStepAuthValid
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("2段階認証の有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor
                                                    .isTwoStepAuthValid,
                                                expression:
                                                  "gateInfor.isTwoStepAuthValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox",
                                              disabled:
                                                _vm.gateInfor.isVisitor ||
                                                _vm.disableTwoStepAuth()
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isTwoStepAuthValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor
                                                      .isTwoStepAuthValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor
                                                    .isTwoStepAuthValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor
                                                      .isTwoStepAuthValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isTwoStepAuthValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isTwoStepAuthValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isTwoStepAuthValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.bleIntensity
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("BLE出力設定")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _vm.gateInfor.makerCode === 2 ||
                                          _vm.gateInfor.makerCode === 4
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.gateInfor
                                                          .bleIntensity,
                                                      expression:
                                                        "gateInfor.bleIntensity"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.gateInfor,
                                                        "bleIntensity",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.listBleIntensityForWafer,
                                                  function(item) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: item.value,
                                                        domProps: {
                                                          value: item.value
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.text) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              )
                                            : _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.gateInfor
                                                          .bleIntensity,
                                                      expression:
                                                        "gateInfor.bleIntensity"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.gateInfor,
                                                        "bleIntensity",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.listBleIntensity,
                                                  function(item) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: item.value,
                                                        domProps: {
                                                          value: item.value
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.text) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ),
                                          _vm._v(" "),
                                          _vm.gateInfor.makerCode === 2 ||
                                          _vm.gateInfor.makerCode === 4
                                            ? _c(
                                                "p",
                                                { staticClass: "note-text" },
                                                [
                                                  _vm._v(
                                                    "「とても強い」「強い」に設定した場合、電池の消耗が早くなります。"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.buzzerPattern
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ブザー鳴動設定")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor.buzzerPattern,
                                                  expression:
                                                    "gateInfor.buzzerPattern"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "buzzerPattern",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(
                                              _vm.listBuzzerPattern,
                                              function(item) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: item.value,
                                                    domProps: {
                                                      value: item.value
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(item.text) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.1")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option1_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option1,
                                          expression: "gateInfor.option1"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option1",
                                        placeholder: "備考.1"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option1
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.validateBeforeSubmit(3)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option1",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.2")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option2_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option2,
                                          expression: "gateInfor.option2"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option2",
                                        placeholder: "備考.2"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option2
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.validateBeforeSubmit(4)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gateSNMain
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲート個体番号1")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.gateInfor.gateSNMain)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gateSNBLE
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲート個体番号2")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.gateInfor.gateSNBLE)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gateFWMain
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "適用されているファームウェアバージョン（メインボード）"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.gateInfor.gateFWMain)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.gateFWBLE
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "適用されているファームウェアバージョン（BLE）"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.gateInfor.gateFWBLE)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.registered
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("登録日")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.converDate(
                                                  _vm.gateInfor.registered
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.updated
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("設定更新日")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.converDate(
                                                  _vm.gateInfor.updated
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.reported
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "ゲートへ設定情報を適用した日時"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.converDate(
                                                  _vm.gateInfor.reported
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.revisionDesired
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "個人コード照合データー：最新リビジョン"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.gateInfor.revisionDesired
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.revisionReported
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "個人コード照合データー：ゲートへ設定済みのリビジョン"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.gateInfor.revisionReported
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.voltage
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("電池電圧")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.gateInfor.voltage)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(
                                _vm.gateInfor.makerCode,
                                _vm.inputIndex.scanDate
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("電池電圧更新日")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.converDate(
                                                  _vm.gateInfor.scanDate
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ステータス")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.isValid,
                                          expression: "gateInfor.isValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.gateInfor.isValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowAnti()
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("アンチパスバックの有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.isAntiPassback,
                                                expression:
                                                  "gateInfor.isAntiPassback"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox",
                                              disabled: _vm.disableAntiPass()
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isAntiPassback
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor
                                                      .isAntiPassback,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.isAntiPassback
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor
                                                      .isAntiPassback,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isAntiPassback = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isAntiPassback = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isAntiPassback",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowAnti()
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("アンチパスバックのモード")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor.antiPassback
                                                      .mode,
                                                  expression:
                                                    "gateInfor.antiPassback.mode"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                id: "anti-mode-level",
                                                "data-placeholder":
                                                  "製品名選択",
                                                disabled: _vm.disableAntiModes()
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor.antiPassback,
                                                    "mode",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.listAntiMode, function(
                                              item
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.value,
                                                  domProps: {
                                                    value: item.value
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.text) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            })
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowAnti()
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [
                                          _vm._v(
                                            "アンチパスバックの対向ゲート名"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", {
                                            staticClass: "error_m",
                                            attrs: {
                                              id: "anti-gate-name-error"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.antiPassback
                                                    .gateName,
                                                expression:
                                                  "gateInfor.antiPassback.gateName"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: {
                                              type: "text",
                                              id: "anti-gate-name",
                                              disabled: true
                                            },
                                            domProps: {
                                              value:
                                                _vm.gateInfor.antiPassback
                                                  .gateName
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.gateInfor.antiPassback,
                                                  "gateName",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-info save_group_bottom",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.disableAntiModes()
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showModalAntiGate()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      対向ゲートの選択\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 text-align-right" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "gates" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.editInforGate }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-style1 panel-group",
                        attrs: { id: "accordion" }
                      },
                      [
                        _c("div", { staticClass: "panel panel-default" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: {
                                id: "relation-gate",
                                "aria-expanded": "true"
                              }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listGateGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllGate,
                                                          expression:
                                                            "selectAllGate"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllGate
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllGate,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllGate
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllGate,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllGate = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllGate = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllGate = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲートグループID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲートグループ名")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listGateGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listGateGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    key: index,
                                                    class: {
                                                      selected: _vm.rowSelectedGate(
                                                        item.relationId
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pos-rel"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedGateId,
                                                                  expression:
                                                                    "selectedGateId"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "ace",
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.relationId,
                                                                checked: Array.isArray(
                                                                  _vm.selectedGateId
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedGateId,
                                                                      item.relationId
                                                                    ) > -1
                                                                  : _vm.selectedGateId
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedGateId,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        item.relationId,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedGateId = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedGateId = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedGateId = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass: "lbl"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.groupId.groupId
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.groupId.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        item.groupId.isValid
                                                          ? _c("span", [
                                                              _vm._v("有効")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("無効")
                                                            ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [_vm._m(3)])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addGroup(_vm.gateInfor.gateId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ゲートグループの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#processGate",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatus()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "チェックしたゲートグループの関連付け解除"
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "panel panel-default" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: { id: "passage" }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listUserGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllUser,
                                                          expression:
                                                            "selectAllUser"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllUser
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllUser,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllUser
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllUser,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllUser = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllUser = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllUser = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ユーザーID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ユーザー名")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ふりがな")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("開始日時")
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("終了日時")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listUserGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listUserGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    key: index,
                                                    class: {
                                                      selected: _vm.rowSelected(
                                                        item.passageId
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pos-rel"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedUserId,
                                                                  expression:
                                                                    "selectedUserId"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "ace",
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.passageId,
                                                                checked: Array.isArray(
                                                                  _vm.selectedUserId
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedUserId,
                                                                      item.passageId
                                                                    ) > -1
                                                                  : _vm.selectedUserId
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedUserId,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        item.passageId,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedUserId = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedUserId = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedUserId = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass: "lbl"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.userId.userId
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.userId.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.userId.furigana
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        item.userId.isValid
                                                          ? _c("span", [
                                                              _vm._v("有効")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("無効")
                                                            ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.converDate(
                                                              item.notBefore
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.converDate(
                                                              item.notAfter
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [_vm._m(5)])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addUser(_vm.gateInfor.gateId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ユーザーの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#process",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatus()
                                      }
                                    }
                                  },
                                  [_vm._v("チェックしたユーザーの関連付け解除")]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このユーザーとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successUser > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countUser) +
                        "件中" +
                        _vm._s(_vm.successUser) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationUser()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processGate", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このゲートとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successGate > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countGate) +
                        "件中" +
                        _vm._s(_vm.successGate) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationGate()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "gate-list", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("×")]
              ),
              _vm._v(" "),
              _c(
                "h3",
                { staticClass: "smaller lighter frofile-title no-margin" },
                [_vm._v("アンチパスバック対向ゲートの選択")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "input-icon search-box" }, [
                _c("input", {
                  ref: "search_modal",
                  staticClass: "nav-search-input",
                  attrs: {
                    type: "text",
                    placeholder: "ユーザーID、ユーザー名検索",
                    id: "nav-search-input",
                    autocomplete: "off"
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "ace-icon fa fa-search nav-search-icon"
                })
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-cusstom green-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.searchGatesForAntipass()
                    }
                  }
                },
                [_vm._v("検索")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.listAntiGates != null && _vm.listAntiGates.length > 0
                ? _c(
                    "table",
                    {
                      staticClass:
                        "table  table-bordered table-hover dataTable",
                      attrs: { id: "simple-table" }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _vm._l(
                        _vm.listAntiGates.slice(
                          _vm.firstItemOfCurrentPage,
                          _vm.lastItemOfCurrentPage
                        ),
                        function(item, index) {
                          return _c("tbody", { key: index }, [
                            _c("tr", [
                              _c("td", { staticClass: "center" }, [
                                _c("label", { staticClass: "pos-rel" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedAntiGateId,
                                        expression: "selectedAntiGateId"
                                      }
                                    ],
                                    staticClass: "ace",
                                    attrs: { type: "radio" },
                                    domProps: {
                                      value: item.gateId,
                                      checked: _vm._q(
                                        _vm.selectedAntiGateId,
                                        item.gateId
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.selectedAntiGateId = item.gateId
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "lbl" })
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "max-width": "150px",
                                    "word-wrap": "break-word"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.gateId) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "max-width": "150px",
                                    "word-wrap": "break-word"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.gateName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        }
                      )
                    ],
                    2
                  )
                : _c(
                    "table",
                    {
                      staticClass:
                        "table  table-bordered table-hover dataTable",
                      attrs: { id: "simple-table" }
                    },
                    [_vm._m(9), _vm._v(" "), _vm._m(10)]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "row pd-t-10" }, [
                _vm.countPageAntipassGate > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "dataTables_paginate paging_simple_numbers"
                      },
                      [
                        _c("paginate", {
                          ref: "gates_paginator",
                          attrs: {
                            "page-count": _vm.countPageAntipassGate,
                            "page-range": 3,
                            "margin-pages": 2,
                            "click-handler": _vm.handleCurrentChange,
                            "prev-text": "<<",
                            "next-text": ">>",
                            "container-class": "pagination",
                            "page-class": "page-item"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger pull-right",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.addAntiGateInfor()
                    }
                  }
                },
                [_vm._v("選択")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("ゲート編集")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [
        _c(
          "a",
          {
            staticClass: "accordion-toggle",
            attrs: { "data-toggle": "collapse", href: "#relation-gate" }
          },
          [
            _c("i", {
              staticClass: "bigger-110 ace-icon fa fa-angle-right",
              attrs: {
                "data-icon-hide": "ace-icon fa fa-angle-down",
                "data-icon-show": "ace-icon fa fa-angle-right"
              }
            }),
            _vm._v(
              "\n                       ゲートグループ\n                    "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [
        _c(
          "a",
          {
            staticClass: "accordion-toggle",
            attrs: {
              "data-toggle": "collapse",
              href: "#passage",
              "aria-expanded": "true"
            }
          },
          [
            _c("i", {
              staticClass: "ace-icon fa fa-angle-right bigger-110",
              attrs: {
                "data-icon-hide": "ace-icon fa fa-angle-down",
                "data-icon-show": "ace-icon fa fa-angle-right"
              }
            }),
            _vm._v(
              "\n                       期限付きゲートを持つユーザー\n                    "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "6" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("ゲートID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲート名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("ゲートID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲート名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tbody", [
      _c("tr", [
        _c("td", { attrs: { colspan: "2" } }, [_vm._v("データーはありません")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-334eb22f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-334eb22f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gate/GateEdit.vue
// module id = null
// module chunks = 